import type { UserMenuItem } from '~/shared/configs/menus';
import { can } from '~/shared/permissions/can';
import type { ShortUserType } from '~/types';

type PushMenuItemIfAllowedParams = Readonly<{
  items: UserMenuItem[];
  user: ShortUserType | null;
  permission: string;
  additionalCheck?: boolean;
  item: UserMenuItem;
}>;

export const pushMenuItemIfAllowed = ({
  items,
  user,
  additionalCheck = true,
  permission,
  item,
}: PushMenuItemIfAllowedParams): void => {
  if (additionalCheck && can(user, permission)) {
    items.push(item);
  }
};
